import React from "react"
import { BrowserRouter, Route } from "react-router-dom"
import HomePage from "src/pages/Home/Home"
const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Route exact path="/" component={HomePage} />
    </BrowserRouter>
  )
}

export default AppRoutes
